import type { HsLayer } from './layer.class';
import type { HsObject3D } from '../objects/common/object-3d.class';

export class HsRenderObjects<T extends HsObject3D, L extends HsLayer> {
  public sortedObjects: T[] = [];
  public unsortedObjects: T[] = [];

  public currentIndex: number = 0;
  public timePerObject: number = -1;
  public distributedObjectsPerFrame: number = 0;
  public distributedFrameInertiaRemaining: number = 0;

  constructor(public layer: L) {}

  public clear(): void {
    this.sortedObjects = [];
    this.unsortedObjects = [];
  }
}
